import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getBanner } from "../store/slices/bannerSlice";

/**
 * Fetches the promotional banner for the active language once the auth token is ready.
 * Returns `null` until there is a live banner, which is what keeps the page unchanged
 * when no campaign is running.
 */
export const useBanner = () => {
  const dispatch = useDispatch();
  const { lang } = useParams();
  const { bannerData, status } = useSelector((state) => state.banner);
  const authStatus = useSelector((state) => state.token.status);

  // The endpoint is language-scoped server-side, and switching language is a client-side
  // route change here - so the request is keyed on the language actually fetched rather
  // than on a one-shot "idle" check, which would leave English artwork on the Arabic page.
  const fetchedLang = useRef(null);

  useEffect(() => {
    const language = lang || "en";
    if (authStatus !== "succeeded" || fetchedLang.current === language) return;
    fetchedLang.current = language;
    dispatch(getBanner(language));
  }, [authStatus, lang, dispatch]);

  return { banner: bannerData, status };
};
